import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
Highcharts.setOptions({
    plotOptions: {
        series: {
            animation: false,
        },
    },
    lang: {
        thousandsSep: ",",
    },
    credits: false,
});
var ChartType7 = function (props) {
    var values = props.values, titles = props.titles, colors = props.colors, prefix = props.prefix, postfix = props.postfix, custom_options = props.custom_options, debug_mood = props.debug_mood;
    var symbol = prefix || "";
    var sign = postfix || "";
    var options = {
        chart: {
            type: "pie",
            backgroundColor: "transparent",
            style: { fontFamily: "Poppins, sans-serif" },
            height: 350,
            reflow: true,
            className: "propel-highchart",
            options3d: {
                enabled: false,
                alpha: 45,
                beta: 0,
            },
        },
        title: {
            useHTML: true,
            text: "",
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        subtitle: {
            useHTML: true,
            text: "",
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        credits: { enabled: false },
        yAxis: {
            title: {
                text: "",
                style: {
                    fontWeight: "normal",
                    fontSize: "12px",
                },
            },
            labels: {
                enabled: true,
                style: {
                    fontWeight: "normal",
                    fontSize: "16px",
                    color: "#000000",
                },
                formatter: function () {
                    return ("$" +
                        Highcharts.numberFormat(this.value / 1, 0) +
                        "").replace(/ /g, "");
                },
            },
        },
        tooltip: {
            enabled: false,
            format: "{point.name}: " + "$" + "{point.y:,.1f}",
            pointFormat: "" + "$" + "{point.y:,.1f}<br/>",
            shared: true,
            useHTML: true,
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        xAxis: {
            title: {
                text: "",
                style: {
                    fontWeight: "normal",
                    fontSize: "12px",
                },
            },
            // categories: chart_categories10664,
            crosshair: true,
            labels: {
                enabled: true,
                style: {
                    fontWeight: "normal",
                    fontSize: "16px",
                    color: "#000000",
                },
            },
        },
        plotOptions: {
            pie: {
                shadow: {
                    color: "#ccc",
                    offsetX: 0,
                    offsetY: 0,
                    opacity: 1,
                    width: 5,
                },
                borderColor: "#ffffff",
                borderWidth: 4,
                allowPointSelect: true,
                cursor: "pointer",
                depth: 35,
                dataLabels: {
                    useHTML: true,
                    connectorShape: "crookedLine",
                    connectorColor: "gray",
                    crookDistance: window.innerWidth > 425 ? "120%" : "40%",
                    softConnector: false,
                    alignTo: "plotEdges",
                    enabled: true,
                    formatter: function () {
                        if (this.y != 0.0) {
                            console.log("y: " + this.color);
                            return ("<span class='chart_label'>" +
                                this.point.name +
                                "</span><br/><span class='chart_value' style='background:" + this.color + "; color: white;font-size:16px; font-weight: bold; float: right;'>" +
                                symbol +
                                "" +
                                Highcharts.numberFormat(this.y / 1, 1) +
                                "" +
                                sign +
                                "</span>");
                        }
                    },
                    style: {
                        textAlign: window.innerWidth > 425 ? "right" : "left",
                        width: window.innerWidth > 425 ? "100px" : "90px",
                        color: "black",
                        fontWeight: "200",
                        fontSize: window.innerWidth > 425 ? "14px" : "9px",
                        fontWeight: "400",
                    },
                },
            },
        },
        legend: {
            enabled: false,
            itemStyle: {
                fontSize: "16px",
                color: "#000000",
            },
        },
    };
    options.series = [
        {
            data: [
                {
                    name: "Safety Stock Margin",
                    y: 60000,
                    color: "#748693",
                },
                {
                    name: "Inventory Cash Reduction",
                    y: 60000,
                    color: "#A2C7E5",
                },
                {
                    name: "Productivity",
                    y: 20000,
                    color: "#28587F",
                },
                {
                    name: "OSA Additional Sales",
                    y: 40000,
                    color: "#458FCA",
                },
                {
                    name: "Waste / Write Off",
                    y: 10000,
                    color: "#011E41",
                },
            ],
        },
    ];
    if (values && titles && values.length > 0 && titles.length == values.length) {
        var data_1 = [];
        values.map(function (value, i) {
            data_1.push({
                name: titles[i],
                y: value,
                color: (colors && colors[i]) || "",
            });
        });
        options.series = [
            {
                data: data_1,
            },
        ];
    }
    var HandleObject = function (object, new_options) {
        Object.keys(object).map(function (e) {
            if (Object.keys(object[e]).length > 0 && typeof object[e] === "object") {
                HandleObject(object[e], new_options[e]);
            }
            else {
                new_options[e] = object[e];
            }
        });
    };
    if (custom_options) {
        if (Object.keys(custom_options).length > 0) {
            Object.keys(custom_options).map(function (e) {
                if (Object.keys(custom_options[e]).length > 0 &&
                    typeof custom_options[e] === "object") {
                    HandleObject(custom_options[e], options[e]);
                }
                else {
                    options[e] = custom_options[e];
                }
            });
        }
    }
    if (debug_mood) {
        console.log("high chart debug mood", options);
    }
    return (React.createElement("div", { className: "ChartType7" },
        React.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};
export default ChartType7;
